import { NgClass, NgOptimizedImage } from '@angular/common';
import { Component, HostListener, Input } from '@angular/core';
import { Product } from '../../../models/product';
import { FileApiService } from '../../../services/apis/file-api.service';

@Component({
  selector: 'app-product-cover',
  imports: [NgOptimizedImage, NgClass],
  templateUrl: './product-cover.html',
  styleUrl: './product-cover.scss',
})
export class ProductCover {
  @Input({ required: true }) data?: Product;
  @Input() front: string = '';
  @Input() back: string = '';
  constructor(private fileApi: FileApiService) {}

  get src1(): string {
    if (this.front) {
      return this.front;
    }
    return this.fileApi.fileurl(this.data?.images[0] || '');
  }
  get src2(): string {
    if (this.back) {
      return this.back;
    }
    return this.fileApi.fileurl(this.data?.images[1] || '');
  }

  isHovered: boolean = false;

  @HostListener('mouseenter')
  onMouseEnter() {
    this.isHovered = true;
  }
  @HostListener('mouseleave')
  onMouseLeave() {
    this.isHovered = false;
  }
}
